module.exports = __webpack_public_path__ + "static/media/nike.67a938c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nike.svg
// module id = 106
// module chunks = 0